import AdyenPrebuiltPayment from './AdyenPrebuiltPayment';

export default AdyenPrebuiltPayment;
